<template>
    <div class="main main-padding new-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
            <!--时间选择器-->
            <div class="time-select-picker">
                <div class="time-select">
                    <Row :gutter="10">
                        <date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>
                    </Row>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <!--标题及搜索框-->
            <div class="details-card-header-area">
                <!--tab切换数据-->
                <div class="details-tab-data">
                    <span>活跃教师使用详情</span>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        placeholder="支持用户名称关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--活跃大屏具体使用详情-->
                <div class="table-wrapper-data">
                    <Table :columns="activeTeaTopColumn" :data="activeTeaTopList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>
<script>
    import dateSelect from "../../../../components/dateSelect.vue";
    import {moreTeachers} from "../../../../service/api.js";

    export default {
        name: "active-tea-top-details",
        data () {
            return {
                schoolId: this.$route.query.schoolId,
                schoolName: this.$route.query.schoolName,
                routerName: this.$route.query.routerName,//路由名称
                selfStartDate: this.$route.query.parentalStartDate,//一级页面传来的开始时间
                selfEndDate: this.$route.query.parentalEndDate,//一级页面传来的结束时间
                parentalStartDate: this.$route.query.parentalStartDate,//记住页面传来的开始时间
                parentalEndDate: this.$route.query.parentalEndDate,//记住页面传来的结束时间
                curSeleMainStartDate: this.$route.query.curSeleMainStartDate,//三级页面传来的开始时间
                curSeleMainEndDate: this.$route.query.curSeleMainEndDate,//三级页面传来的结束时间
                userId: this.$route.query.userId,
                type: this.$route.query.type,
                keyWord: "",
                page: 1,
                limit: 10,
                total:0,
                pageCount: 0,//页数
                activeTeaTopColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "用户名称",
                        key: "fullName",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "点击进入教师使用具体详情页面",
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "#0199ff",
                                            fontSize: "14px",
                                        },
                                        on: {
                                            click: () => {
                                                this.goUseDetails(params.row, params.index);
                                            }
                                        }
                                    },
                                    params.row.fullName
                                )
                            ]);
                        }
                    },
                    {
                        title: "次数",
                        key: "count",
                        align: "center",
                    }
                ],
                activeTeaTopList: [],//数据集合
            }
        },
        components: {
            dateSelect
        },
        methods: {
            /**
             *获取活跃大屏具体使用详情数据
             */
            async moreTeachers () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.selfStartDate,
                    endTime: _this.selfEndDate,
                    userId: _this.userId,
                    type: _this.type,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await moreTeachers(params)
                    .then(function (data) {
                        if (Object.keys(data).length !== 0) {
                            _this.activeTeaTopList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 翻页
             */
            handleCurrentChange(val){
                this.page = val;
                this.moreTeachers();
            },
            /**
             * 翻页
             */
            handleSearch(){
                this.total = 0;
                this.page = 1;
                this.moreTeachers();
            },
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: this.routerName,
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        startDate: this.type===1?this.curSeleMainStartDate:this.parentalStartDate,
                        endDate: this.type===1?this.curSeleMainEndDate:this.parentalEndDate,
                    }
                });
            },
            /**
             * 点击进入教师使用具体详情页面
             */
            goUseDetails (row, index) {
                this.$router.push({
                    name: "activeTeaDetails",
                    query: {
                        schoolId: this.schoolId,
                        selfStartDate: this.selfStartDate,
                        selfEndDate: this.selfEndDate,
                        parentalStartDate: this.parentalStartDate,
                        parentalEndDate: this.parentalEndDate,
                        schoolName: this.schoolName,
                        routerName: this.routerName,
                        tabsName: "",
                        isShowRemind: "",
                        teaName: 'notAddTime',
                        userId: row.userId,
                        sourceType: -1
                    }
                });
            },
            /**
             * 更新开始时间结束时间
             */
            updateDateTime (startDate, endDate) {
                this.page=1;
                this.selfStartDate = startDate;
                this.selfEndDate = endDate;
                this.moreTeachers();
            }
        },
        mounted () {
            //修改公共属性学校名称
            this.$store.commit("SET_TOPHEADERNAME", this.schoolName);
            //获取班级安装大屏详情数据
            this.moreTeachers();
            //记住页面选择的开始和结束时间
            this.$refs.dateSelect.setDate(this.parentalStartDate, this.parentalEndDate);
        }
    };
</script>
<style lang="scss" scoped>
    @import "../../../../style/home";
    @import "../../../../style/dataDetails";
</style>
<style lang="scss">
    .new-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
        }

        .ivu-card-body {
            padding: 16px;
        }
        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }
        .ivu-row {
            margin-top: 0 !important;
        }
        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }
        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
